module.exports = __webpack_public_path__ + "static/og-image-f5034df8c60c72f6dacce2caf516306a.png";